import React from 'react'
import '../News/News.css'
import { Link } from 'react-router-dom'

//Assets
import shreeKant from "../../../assets/images/srikant press release (2).png"

const  News=()=> {
    
    const array=[
        {
            img:`${process.env.REACT_APP_IMAGEBASE_URL}/NueGo%20All%20Sleeper_300-X-300-px_Desktop-Home-Pg.jpg`,
            paragragh:"NueGo sets Industry Benchmark by equipping its Entire Electric Bus Fleet with ADAS",
            link:"#Blog1"
        },
        {
            img:`${process.env.REACT_APP_IMAGEBASE_URL}/Nuego%20X%20Housefull%205_300-X-300-px_Desktop-Home-Pg.jpg`,
            paragragh:"NueGo Teams Up with Bollywood’s Biggest Comedy Franchise – Housefull 5 – to Drive Eco-Friendly Travel with a Dose of Madness!",
            link:"#Blog2"
        },
        {
            img:`${process.env.REACT_APP_IMAGEBASE_URL}/NueGo%20Bus_300-X-300-px_Desktop-Home-Pg.jpg`,
            paragragh:"India's homegrown brand NueGo has launched the Delhi-Lucknow route, pioneering sustainable travel in India",
            link:"#Blog3"
        },

  
    ]

    return (

        <section className='news_section'>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h2>Recent News</h2>
                        <div className='news-list'>
                        <ul>
                            {array.map((items,id)=>{
                              return  <li  className='imagenewsss' >                                   
                              <img src={items.img} alt="blog1"  className='imagessss' />
                              <p>{items.paragragh} ​</p>
                              <Link  to={`/news${items.link}`} >Read More 
                               {/* <img src={blogarrow} alt='blogarrow img' />  */}
                               <img src={`${process.env.REACT_APP_IMAGEBASE_URL}/arrow.svg`} alt='blogarrow img'    />   
                               </Link>
                            </li>
                            }) }
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
    )
}

export default News
